import { JSX, useCallback, useMemo } from "react";

import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";

import ClearIcon from "@mui/icons-material/Clear";

import useFetch from "utils/fetch/useFetch";
import useGet from "utils/fetch/useGet";

import ResourceClient from "resource/ResourceClient";

export type SelectFormAttachmentProps = {
	index: number;
	id: number;
	onRemoveAttachment: (index: number) => void;
};

export function SelectFormAttachment(
	props: Readonly<SelectFormAttachmentProps>
): JSX.Element {
	const { response } = useGet(ResourceClient.getInfo(props.id));
	const { call } = useFetch();

	const name = useMemo((): string => {
		return (
			(response.state === "SUCCESS" && response.data.name) ||
			props.id.toString()
		);
	}, [props.id, response.state]);

	const openAttachment = useCallback(() => {
		call(ResourceClient.getContent(props.id)).then(content => {
			const url = window.URL.createObjectURL(content);
			window.open(url, "_blank");
		});
	}, [props.id, name]);

	const removeAttachment = useCallback((): void => {
		props.onRemoveAttachment(props.index);
	}, [props.index, props.onRemoveAttachment]);

	return (
		<Grid container alignItems="center">
			<Grid item>
				<Link sx={{ cursor: "pointer" }} onClick={openAttachment}>
					{name}
				</Link>
			</Grid>
			<Grid item>
				<IconButton size="small" onClick={removeAttachment}>
					<ClearIcon />
				</IconButton>
			</Grid>
		</Grid>
	);
}
